
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3576",
  depVersions: {
  "customer-portal-app": "static-1.3576",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.3032",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10179",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "growth-payments-core": "static-1.26643",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6134",
  "hs-test-utils": "static-1.8586",
  "hub-http": "static-1.6746",
  "hub-http-shared-msw-handlers": "static-1.11016",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19417",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12034",
  "I18n": "static-7.1727",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.7003",
  "payment-link-components": "static-1.24602",
  "portals-platform-bend-plugin": "static-1.30",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7775",
  "quartz-core": "static-1.6994",
  "quartz-i18n": "static-1.1450",
  "react": "static-7.206",
  "react-colorpicker": "static-2.10754",
  "react-dlb": "static-1.97",
  "react-utils": "static-2.5722",
  "reselect": "static-3.20",
  "rich-text-lib": "static-1.20656",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18616",
  "ui-components-test-utils": "static-1.6171",
  "UIComponents": "static-3.8980",
  "video-player-core": "static-1.24",
  "foundations-assets": "static-1.5433",
  "foundations-components": "static-1.8860",
  "foundations-theming": "static-1.5047",
  "foundations-theming-specialty": "static-1.2763",
  "framer-motion": "static-1.87",
  "hs-browser-apis": "static-1.18",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.459",
  "portals-platform-lib": "static-1.1785",
  "pulse": "static-1.1217",
  "quartz-config": "static-1.1553",
  "quartz-routing": "static-1.1205",
  "quick-fetch": "static-1.4270",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17284",
  "rpc-client-utils": "static-1.5210",
  "sanitize-text": "static-1.8701",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.69",
  "ui-addon-draggable": "static-3.5296",
  "ui-addon-react-router-dom": "static-1.10073",
  "usage-tracker": "static-1.7890",
  "usage-tracker-anonymous": "static-1.6307",
  "usage-tracker-core": "static-1.7740",
  "video-components-external": "static-1.12569",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4052",
  "quartz-webpack": "static-1.3999",
  "bend-plugin-quartz-routing": "static-1.853",
  "hub-http-janus": "static-1.923",
  "hubspotter-http": "static-1.5013",
  "icons": "static-2.719",
  "StyleGuideUI": "static-3.523",
  "stylex": "static-1.50",
  "trellis-components": "static-1.3297",
  "trellis-migration-context": "static-1.122",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.96",
  "customer-data-objects": "static-1.8259",
  "frontend-preferences-client": "static-1.8467",
  "laboratory-lib": "static-3.7693",
  "onboarding-scopes": "static-1.6996",
  "seat-types-lib": "static-1.1189",
  "ui-addon-opt": "static-4.8983",
  "HeadJS": "static-2.839",
  "hs-test-utils-bend-plugin": "static-1.3697",
  "msw": "static-1.106",
  "msw-config": "static-1.46",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.446",
  "ts-schema": "static-1.4437",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8512",
  "content-media-capture": "static-1.5902",
  "cssUtils": "static-1.1164",
  "customer-data-ui-utilities": "static-1.10377",
  "file-manager-components": "static-1.24950",
  "HubStyle": "static-2.12341",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3420",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10409",
  "ui-addon-i18n": "static-1.11692",
  "ui-business-units-lib": "static-1.9641",
  "ui-shepherd-react": "static-3.10831",
  "video-data-lib": "static-1.36227",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4849",
  "commerce-tours-lib": "static-1.6958",
  "getting-started-shared-tasks": "static-1.19678",
  "growth-onboarding-reliability": "static-1.5627",
  "onboarding-tours": "static-1.17492",
  "reference-resolvers-lite": "static-1.8657",
  "sales-checkout-service-client": "static-1.4063",
  "ui-addon-iframeable": "static-1.9623",
  "user-context": "static-1.5599",
  "bender-build-tools": "static-1.3654",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.623",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.719",
  "quartz-auth": "static-1.1450",
  "quartz-head": "static-1.1440",
  "quartz-test": "static-1.1450",
  "quartz-tracking": "static-1.1154",
  "ui-fonts": "static-1.1296",
  "usage-tracker-container": "static-1.7880",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9968",
  "data-token-picker": "static-1.17233",
  "FileManagerLib": "static-1.40590",
  "property-translator": "static-1.5919",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6728",
  "SharedI18nStrings": "static-1.191",
  "foundations-components-test-utils": "static-1.6343",
  "react-create-root-preference": "static-1.125",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "ui-images": "static-2.1299",
  "bend-plugin-foundations-components": "static-1.5129",
  "floating-ui": "static-1.71",
  "react-aria": "static-1.80",
  "trellis-assets": "static-1.3278",
  "bend-plugin-foundations-theming": "static-1.3530",
  "foundations-theming-base": "static-1.4032",
  "interframe": "static-3.5289",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6304",
  "batch-promise": "static-1.2095",
  "bend-plugin-pulse": "static-1.720",
  "chirp-fetch": "static-1.2444",
  "event-emitter": "static-1.1501",
  "fast-json-patch": "static-1.79",
  "immer": "static-1.107",
  "opentelemetry-fe-types": "static-1.344",
  "beacon-keepalive-queue": "static-1.246",
  "web-vitals": "static-1.22",
  "bend-plugin-chirp-manifest": "static-1.620",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5012",
  "react-flip-move": "static-1.86",
  "apollo-link-hub-http": "static-2.5133",
  "content-media-composition-data-lib": "static-1.13706",
  "content-media-compositions": "static-2.17713",
  "idb-keyval": "static-1.59",
  "immerable": "static-1.4688",
  "magpie-lib": "static-1.5967",
  "magpie-types": "static-1.5427",
  "media-bridge-lib": "static-1.19739",
  "sassPrefix": "static-1.431",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "trellis-theming": "static-1.1589",
  "inbound-db-properties-service-client": "static-1.4193",
  "superstore": "static-1.5299",
  "feedback-loader": "static-1.30158",
  "ai-components-ui-library": "static-1.10145",
  "ui-addon-video-player": "static-1.9166",
  "ui-coaching-tips": "static-1.29647",
  "ContentUtils": "static-1.69633",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4973",
  "react-dnd-compat": "static-1.5154",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2407",
  "copilot-toolkit": "static-1.12281",
  "poll-commands": "static-1.4019",
  "atom": "static-1.5617",
  "navigation-messaging": "static-1.8675",
  "redux-thunk": "static-2.88",
  "reference-resolvers": "static-1.8730",
  "commerce-products-lib": "static-1.11114",
  "crm-message-bus": "static-1.44274",
  "growth-data-modal": "static-1.6227",
  "hubspot-apollo-client": "static-1.5420",
  "onboarding-tours-client": "static-1.5707",
  "growth-onboarding-confetti": "static-1.3601",
  "growth-onboarding-next-action-utils": "static-1.3115",
  "navigation-components": "static-1.19348",
  "nest": "static-1.783",
  "onboarding-tours-utils": "static-1.1559",
  "ui-shepherd-tracker": "static-1.8212",
  "ui-universal-auth": "static-1.9876",
  "external-options-client-types": "static-1.4478",
  "hs-resources": "static-1.740",
  "getting-started-shared-tasks-store": "static-1.18796",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11014",
  "usage-tracker-session-replay": "static-1.5576",
  "audio-components": "static-1.6661",
  "FileManagerCore": "static-1.40449",
  "FileManagerImages": "static-1.38101",
  "video-components": "static-1.14571",
  "foundations-components-legacy": "static-1.1885",
  "purchase-motions-api": "static-1.6731",
  "signup-constants": "static-1.20128",
  "signup-ui-url-generator": "static-2.8579",
  "stylex-utils": "static-1.194",
  "usage-tracker-public": "static-1.7701",
  "reactive-lib": "static-1.1266",
  "simple-logging-lib": "static-1.3591",
  "nudge-client-utils": "static-1.3522",
  "chatspot-core": "static-1.24324",
  "customer-data-objects-ui-components": "static-1.13581",
  "growth-onboarding-feedback-components": "static-1.7129",
  "cms-field-types": "static-1.5357",
  "content-icons-ui": "static-1.2527",
  "integrations-lib": "static-1.17576",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1385",
  "breeze-engine-core": "static-1.1685",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30985",
  "commerce-permissions": "static-1.1324",
  "customer-data-tracking": "static-1.7414",
  "products-iframe-lib": "static-1.9070",
  "products-ui-components-shared-msw-handlers": "static-1.11398",
  "onboarding-data-sync-lib": "static-1.2931",
  "hubspot-apollo-cache": "static-1.879",
  "growth-onboarding-next-action-components": "static-1.3143",
  "user-context-client": "static-1.5052",
  "custom-vendor-connection-lib": "static-1.440",
  "unified-auth-core-lib": "static-1.1672",
  "conditional-properties-service-client": "static-1.4154",
  "crm-pipelines-api-client-types": "static-1.4487",
  "fdsr-migration-layer": "static-1.558",
  "framework-builder-read-service-client": "static-1.4374",
  "inbound-db-meta-service-client": "static-1.3813",
  "multi-currency-client-types": "static-1.4052",
  "amplitude-session-replay-browser": "static-1.80",
  "breeze-artifacts-sdk": "static-1.1236",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.70",
  "redux-toolkit": "static-1.85",
  "salesImages": "static-1.802",
  "urlinator": "static-1.5061",
  "video-embed": "static-1.37061",
  "social-insights-client-types": "static-1.23059",
  "nudge-custom-function-registry": "static-1.3279",
  "nudge-renderer-utils": "static-1.3598",
  "whisper-core-api": "static-1.7755",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14991",
  "integrations-tracking-lib": "static-1.6172",
  "native-integrations-shared-strings": "static-1.8302",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10916",
  "rxjs": "static-5.10",
  "sales-views-client-types": "static-1.4802",
  "InboxConnectUtils": "static-4.15971",
  "meetings-connect-utils-lib": "static-1.8163",
  "codemirror": "static-5.109",
  "fsm": "static-1.4305",
  "react-codemirror": "static-1.11185",
  "persist-promise": "static-1.4252",
  "outpost": "static-1.4669",
  "universal-page-editor-lib": "static-1.3564",
  "hub-http-contrib": "static-1.3574",
  "ui-addon-sales-email": "static-1.5751",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "crm-record-cards-client": "static-1.248",
  "crm-record-cards-service-types": "static-1.3897",
  "framework-data-schema-resolvers": "static-1.7432",
  "location-customization-utils-lib": "static-1.10565",
  "framework-data-schema-quick-fetch": "static-1.7337"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3576",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.3032",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10179",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "growth-payments-core": "/growth-payments-core/static-1.26643",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6134",
  "hs-test-utils": "/hs-test-utils/static-1.8586",
  "hub-http": "/hub-http/static-1.6746",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11016",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19417",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12034",
  "I18n": "/I18n/static-7.1727",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.7003",
  "payment-link-components": "/payment-link-components/static-1.24602",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.30",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7775",
  "quartz-core": "/quartz-core/static-1.6994",
  "quartz-i18n": "/quartz-i18n/static-1.1450",
  "react": "/react/static-7.206",
  "react-colorpicker": "/react-colorpicker/static-2.10754",
  "react-dlb": "/react-dlb/static-1.97",
  "react-utils": "/react-utils/static-2.5722",
  "reselect": "/reselect/static-3.20",
  "rich-text-lib": "/rich-text-lib/static-1.20656",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18616",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6171",
  "UIComponents": "/UIComponents/static-3.8980",
  "video-player-core": "/video-player-core/static-1.24",
  "foundations-assets": "/foundations-assets/static-1.5433",
  "foundations-components": "/foundations-components/static-1.8860",
  "foundations-theming": "/foundations-theming/static-1.5047",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2763",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "portals-platform-lib": "/portals-platform-lib/static-1.1785",
  "pulse": "/pulse/static-1.1217",
  "quartz-config": "/quartz-config/static-1.1553",
  "quartz-routing": "/quartz-routing/static-1.1205",
  "quick-fetch": "/quick-fetch/static-1.4270",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17284",
  "rpc-client-utils": "/rpc-client-utils/static-1.5210",
  "sanitize-text": "/sanitize-text/static-1.8701",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.69",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5296",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10073",
  "usage-tracker": "/usage-tracker/static-1.7890",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6307",
  "usage-tracker-core": "/usage-tracker-core/static-1.7740",
  "video-components-external": "/video-components-external/static-1.12569",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4052",
  "quartz-webpack": "/quartz-webpack/static-1.3999",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.853",
  "hub-http-janus": "/hub-http-janus/static-1.923",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "icons": "/icons/static-2.719",
  "StyleGuideUI": "/StyleGuideUI/static-3.523",
  "stylex": "/stylex/static-1.50",
  "trellis-components": "/trellis-components/static-1.3297",
  "trellis-migration-context": "/trellis-migration-context/static-1.122",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.96",
  "customer-data-objects": "/customer-data-objects/static-1.8259",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8467",
  "laboratory-lib": "/laboratory-lib/static-3.7693",
  "onboarding-scopes": "/onboarding-scopes/static-1.6996",
  "seat-types-lib": "/seat-types-lib/static-1.1189",
  "ui-addon-opt": "/ui-addon-opt/static-4.8983",
  "HeadJS": "/HeadJS/static-2.839",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3697",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.46",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.446",
  "ts-schema": "/ts-schema/static-1.4437",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8512",
  "content-media-capture": "/content-media-capture/static-1.5902",
  "cssUtils": "/cssUtils/static-1.1164",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10377",
  "file-manager-components": "/file-manager-components/static-1.24950",
  "HubStyle": "/HubStyle/static-2.12341",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3420",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10409",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11692",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9641",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10831",
  "video-data-lib": "/video-data-lib/static-1.36227",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4849",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6958",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19678",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5627",
  "onboarding-tours": "/onboarding-tours/static-1.17492",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8657",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4063",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9623",
  "user-context": "/user-context/static-1.5599",
  "bender-build-tools": "/bender-build-tools/static-1.3654",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.623",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.719",
  "quartz-auth": "/quartz-auth/static-1.1450",
  "quartz-head": "/quartz-head/static-1.1440",
  "quartz-test": "/quartz-test/static-1.1450",
  "quartz-tracking": "/quartz-tracking/static-1.1154",
  "ui-fonts": "/ui-fonts/static-1.1296",
  "usage-tracker-container": "/usage-tracker-container/static-1.7880",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9968",
  "data-token-picker": "/data-token-picker/static-1.17233",
  "FileManagerLib": "/FileManagerLib/static-1.40590",
  "property-translator": "/property-translator/static-1.5919",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6728",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6343",
  "react-create-root-preference": "/react-create-root-preference/static-1.125",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "ui-images": "/ui-images/static-2.1299",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5129",
  "floating-ui": "/floating-ui/static-1.71",
  "react-aria": "/react-aria/static-1.80",
  "trellis-assets": "/trellis-assets/static-1.3278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3530",
  "foundations-theming-base": "/foundations-theming-base/static-1.4032",
  "interframe": "/interframe/static-3.5289",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6304",
  "batch-promise": "/batch-promise/static-1.2095",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.720",
  "chirp-fetch": "/chirp-fetch/static-1.2444",
  "event-emitter": "/event-emitter/static-1.1501",
  "fast-json-patch": "/fast-json-patch/static-1.79",
  "immer": "/immer/static-1.107",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.344",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.246",
  "web-vitals": "/web-vitals/static-1.22",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.620",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5012",
  "react-flip-move": "/react-flip-move/static-1.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5133",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13706",
  "content-media-compositions": "/content-media-compositions/static-2.17713",
  "idb-keyval": "/idb-keyval/static-1.59",
  "immerable": "/immerable/static-1.4688",
  "magpie-lib": "/magpie-lib/static-1.5967",
  "magpie-types": "/magpie-types/static-1.5427",
  "media-bridge-lib": "/media-bridge-lib/static-1.19739",
  "sassPrefix": "/sassPrefix/static-1.431",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "trellis-theming": "/trellis-theming/static-1.1589",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4193",
  "superstore": "/superstore/static-1.5299",
  "feedback-loader": "/feedback-loader/static-1.30158",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10145",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9166",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29647",
  "ContentUtils": "/ContentUtils/static-1.69633",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4973",
  "react-dnd-compat": "/react-dnd-compat/static-1.5154",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2407",
  "copilot-toolkit": "/copilot-toolkit/static-1.12281",
  "poll-commands": "/poll-commands/static-1.4019",
  "atom": "/atom/static-1.5617",
  "navigation-messaging": "/navigation-messaging/static-1.8675",
  "redux-thunk": "/redux-thunk/static-2.88",
  "reference-resolvers": "/reference-resolvers/static-1.8730",
  "commerce-products-lib": "/commerce-products-lib/static-1.11114",
  "crm-message-bus": "/crm-message-bus/static-1.44274",
  "growth-data-modal": "/growth-data-modal/static-1.6227",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5420",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5707",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3601",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3115",
  "navigation-components": "/navigation-components/static-1.19348",
  "nest": "/nest/static-1.783",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1559",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8212",
  "ui-universal-auth": "/ui-universal-auth/static-1.9876",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "hs-resources": "/hs-resources/static-1.740",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18796",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11014",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5576",
  "audio-components": "/audio-components/static-1.6661",
  "FileManagerCore": "/FileManagerCore/static-1.40449",
  "FileManagerImages": "/FileManagerImages/static-1.38101",
  "video-components": "/video-components/static-1.14571",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1885",
  "purchase-motions-api": "/purchase-motions-api/static-1.6731",
  "signup-constants": "/signup-constants/static-1.20128",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8579",
  "stylex-utils": "/stylex-utils/static-1.194",
  "usage-tracker-public": "/usage-tracker-public/static-1.7701",
  "reactive-lib": "/reactive-lib/static-1.1266",
  "simple-logging-lib": "/simple-logging-lib/static-1.3591",
  "nudge-client-utils": "/nudge-client-utils/static-1.3522",
  "chatspot-core": "/chatspot-core/static-1.24324",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13581",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7129",
  "cms-field-types": "/cms-field-types/static-1.5357",
  "content-icons-ui": "/content-icons-ui/static-1.2527",
  "integrations-lib": "/integrations-lib/static-1.17576",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1385",
  "breeze-engine-core": "/breeze-engine-core/static-1.1685",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30985",
  "commerce-permissions": "/commerce-permissions/static-1.1324",
  "customer-data-tracking": "/customer-data-tracking/static-1.7414",
  "products-iframe-lib": "/products-iframe-lib/static-1.9070",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11398",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2931",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.879",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3143",
  "user-context-client": "/user-context-client/static-1.5052",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.440",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1672",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4154",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4487",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.558",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3813",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4052",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1236",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "salesImages": "/salesImages/static-1.802",
  "urlinator": "/urlinator/static-1.5061",
  "video-embed": "/video-embed/static-1.37061",
  "social-insights-client-types": "/social-insights-client-types/static-1.23059",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3279",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3598",
  "whisper-core-api": "/whisper-core-api/static-1.7755",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14991",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6172",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8302",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10916",
  "rxjs": "/rxjs/static-5.10",
  "sales-views-client-types": "/sales-views-client-types/static-1.4802",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15971",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8163",
  "codemirror": "/codemirror/static-5.109",
  "fsm": "/fsm/static-1.4305",
  "react-codemirror": "/react-codemirror/static-1.11185",
  "persist-promise": "/persist-promise/static-1.4252",
  "outpost": "/outpost/static-1.4669",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3564",
  "hub-http-contrib": "/hub-http-contrib/static-1.3574",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5751",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.248",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3897",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337"
}
};
